import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import DocumentsActionModel from "./models/DocumentActionModel";
import DocumentsDownloadActionModel from "./models/DocumentsDownloadActionModel";
import DocumentsInfoModel from "./models/DocumentsInfoModel";
import InfoDocumentsModel from "./models/InfoDocumentsModel";
import DocumentsSignStatusModel from "./models/DocumentsSignStatusModel";

export interface IDocumentsRequest {
    estimateId: number;
    documentName: string;
    documentCode: string;
}
export interface IUploadDocumentsRequest {
    documentFile?: File;
    documentName?: string;
    idRequestType?: number;
    idAdministrativeCategory?: number;
    documentDescription?: string;
    documentType?: number;
    idEstimateRequest?: number;
    documentCode?: string;
    idEstimate?: number;
}

export interface IDeleteDocumentsRequest {
    documentType: number;
    idEstimateRequest: number;
    documentCode: string;
    printDossierCode: number;
    fileId: string;
    fileName: string;
    idEstimate?: number;
}

export interface IGenerateDocumentsRequest {
    documentType: number;
    idEstimateRequest: number;
    documentCode: string;
    printCode: number;
    documentName: string;
    idEstimate: number;
}

export interface IDownloadDocumentsRequest {
    documentType: number;
    idEstimateRequest: number;
    idEstimate: number;
    documentCode: string;
    fileId: string;
    fileName: string;
}

export interface ISignRequest {
    customerName: string;
    customerSurname: string;
    customerMobile: string;
    customerEmail: string;
    files: InfoDocumentsModel[];
    idAgent?: number;
    idEstimateRequest?: number;
    idEstimate?: number;
}
export interface ISignStatusRequest {
    idEstimateRequest: number;
    idProcess: string;
    idEstimate: number;
}
export interface ISignCancelRequest {
    idEstimateRequest: number;
    idProcess: string;
}

export default class DocumentsEffect {
    public static async getDocumentsInfo(
        idEstimateRequest: number,
        idEstimate: number
    ): Promise<DocumentsInfoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.documentiInfoGet;
        return EffectUtility.getToModel<DocumentsInfoModel>(DocumentsInfoModel, endpoint, {
            estimateRequestId: idEstimateRequest,
            estimateId: idEstimate,
        });
    }

    public static async uploadDocument(
        request: IUploadDocumentsRequest
    ): Promise<DocumentsActionModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.documentiUpload;
        return EffectUtility.postFormDataToModel<DocumentsActionModel>(DocumentsActionModel, endpoint, request);
    }

    public static async deleteDocument(
        request: IDeleteDocumentsRequest
    ): Promise<InfoDocumentsModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.documentiDelete;
        return EffectUtility.postToModel<InfoDocumentsModel>(InfoDocumentsModel, endpoint, request);
    }

    public static async generateDocument(
        request: IGenerateDocumentsRequest
    ): Promise<DocumentsActionModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.documentiGenerate;
        return EffectUtility.postToModel<DocumentsActionModel>(DocumentsActionModel, endpoint, request);
    }

    public static async downloadDocument(
        request: IDownloadDocumentsRequest,
        progressHandler: (progress: number) => void
    ): Promise<Blob | HttpErrorResponseModel> {
        const endpoint: string = environment.api.documentiDownload;
        return EffectUtility.getFile(endpoint, request, undefined, "POST");
    }

    public static async downloadStaticDocument(
        request: IDownloadDocumentsRequest,
        progressHandler: (progress: number) => void
    ): Promise<Blob | HttpErrorResponseModel> {
        const endpoint: string = environment.api.documentiStaticiDownload;
        return EffectUtility.getFile(endpoint, request, undefined, "POST");
    }

    public static async sign(request: ISignRequest): Promise<DocumentsSignStatusModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.sign;
        return EffectUtility.postToModel<DocumentsSignStatusModel>(DocumentsSignStatusModel, endpoint, request);
    }
    public static async signStatus(
        request: ISignStatusRequest
    ): Promise<DocumentsSignStatusModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.signStatus;
        return EffectUtility.getToModel<DocumentsSignStatusModel>(DocumentsSignStatusModel, endpoint, request);
    }
    public static async signCancel(
        request: ISignCancelRequest
    ): Promise<DocumentsSignStatusModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.signCancel;
        return EffectUtility.getToModel<DocumentsSignStatusModel>(DocumentsSignStatusModel, endpoint, request);
    }
}
